const getJson = url => fetch(url).then(response => response.json());

const getCourses = () =>
  getJson("/db.json")
    .then(res => res.courses)
    .catch(error => console.error(error));

export { getCourses };



// WEBPACK FOOTER //
// ./src/api.js